export const getObjectValueByKey = (obj, key) => {
  return Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : null
}
